import {
  GET_CATEGORIES_REQUESTED,
  GET_CATEGORIES_SUCCEEDED,
  GET_CATEGORIES_FAILED,
  UPDATE_CATEGORIES_REQUESTED,
  UPDATE_CATEGORIES_SUCCEEDED,
  UPDATE_CATEGORIES_FAILED,
  CREATE_CATEGORY_REQUESTED,
  CREATE_CATEGORY_SUCCEEDED,
  CREATE_CATEGORY_FAILED,
  SET_CATEGORIES_INDEXES,
  UPDATE_REPORTING_CATEGORY_REQUESTED,
  UPDATE_REPORTING_CATEGORY_SUCCEEDED,
  UPDATE_REPORTING_CATEGORY_FAILED,
  CREATE_REPORTING_CATEGORY_REQUESTED,
  CREATE_REPORTING_CATEGORY_SUCCEEDED,
  CREATE_REPORTING_CATEGORY_FAILED,
  SEARCH_MODIFIER_GROUP_SUCCEEDED,
  SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY,
} from './constants'
import DataMapper from '../../utils/dataMapper'

export const defaultState = {}

const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_CATEGORIES_REQUESTED:
      return { ...state, isLoading: true }

    case GET_CATEGORIES_SUCCEEDED:
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        all: payload,
        byId,
        isLoading: false,
      }
    case GET_CATEGORIES_FAILED:
      return { ...state, isLoading: false }

    case CREATE_CATEGORY_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case CREATE_CATEGORY_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)
      return {
        ...state,
        all: [...state.all, payload],
        byId: {
          ...state.byId,
          ...byId,
        },
        isLoading: false,
      }
    }

    case CREATE_CATEGORY_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case UPDATE_CATEGORIES_REQUESTED:
      return { ...state, isLoading: true }

    case UPDATE_CATEGORIES_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        all: [...state.all, payload],
        byId: {
          ...state.byId,
          ...byId,
        },
        isLoading: false,
      }
    }

    case UPDATE_CATEGORIES_FAILED:
      return { ...state, isLoading: false }

    case SET_CATEGORIES_INDEXES:
      return { ...state, categoriesIndexes: payload }

    case UPDATE_REPORTING_CATEGORY_REQUESTED:
      return { ...state, isLoading: true }

    case UPDATE_REPORTING_CATEGORY_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)
      return {
        ...state,
        all: [...state.all, payload],
        byId: { ...state.byId, ...byId },
        isLoading: false,
      }
    }

    case UPDATE_REPORTING_CATEGORY_FAILED:
      return { ...state, isLoading: false }

    case CREATE_REPORTING_CATEGORY_REQUESTED:
      return { ...state, isLoading: true }

    case CREATE_REPORTING_CATEGORY_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        all: [...state.all, payload],
        byId: { ...state.byId, ...byId },
        isLoading: false,
      }
    }
    case CREATE_REPORTING_CATEGORY_FAILED:
      return { ...state, isLoading: false }

    case SEARCH_MODIFIER_GROUP_SUCCEEDED:
      return {
        ...state,
        filters: {
          ...state.filters,
          modifierGroups: {
            searchModifierGroupsValue: payload,
          },
        },
      }

    case SELECT_ITEMS_ASSIGNED_TO_DISPLAY_CATEGORY: {
      const { categoryId, selectedItems } = payload
      return {
        ...state,
        selectedItemsAssignedToDisplayCategory: {
          [categoryId]: selectedItems,
        },
      }
    }

    default:
      return state
  }
}

export default state
